var _classCallCheck = require("/Users/tamir/work/websites/markidim/markidim_web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/tamir/work/websites/markidim/markidim_web/node_modules/@babel/runtime/helpers/createClass");

/**
  Encapsulating integrations with Google-Analytics and Mixpanel (for now)
  Some API methods will only call one integration and some will call all.
*/
var googleTracker = false;
var mixpanelDriver = false;

var CLIntegrations =
/*#__PURE__*/
function () {
  "use strict";

  function CLIntegrations(config) {
    _classCallCheck(this, CLIntegrations);

    console.log(config);
    this.platform = config.platform; // initialize

    if (config.platform == 'reactjs') {
      if (config.vendors.GOOGLE.key) {
        config.vendors.GOOGLE.driver.initialize(config.vendors.GOOGLE.key);
        googleTracker = config.vendors.GOOGLE.driver;
      }

      if (config.vendors.MIXPANEL.key) {
        config.vendors.MIXPANEL.driver.init(config.vendors.MIXPANEL.key); // config.vendors.MIXPANEL.driver.trackWithProperties = config.vendors.MIXPANEL.driver.track
        // config.vendors.MIXPANEL.driver.set = config.vendors.MIXPANEL.driver.people.set

        mixpanelDriver = config.vendors.MIXPANEL.driver;
      }
    } else {
      // init trackers - both GA and MP if we have keys in config
      if (config.vendors.GOOGLE.key) {
        googleTracker = new config.vendors.GOOGLE.driver(config.vendors.GOOGLE.key);
      }

      if (config.vendors.MIXPANEL.key) {
        config.vendors.MIXPANEL.driver.sharedInstanceWithToken(config.vendors.MIXPANEL.key);
        mixpanelDriver = config.vendors.MIXPANEL.driver;
      }
    }
  }

  _createClass(CLIntegrations, [{
    key: "identify",
    value: function identify(id, params) {
      // console.log(id, params);
      if (googleTracker) {
        if (this.platform == 'reactjs') {
          googleTracker.set({
            userId: id
          });
        } else {
          googleTracker.setUser(id);
        }
      }

      if (mixpanelDriver) {
        // first the id
        // Mixpanel.identify(id);
        mixpanelDriver.identify(id); //   Properties should follow Mixpanel rules:
        // for example, if you call the email '$email' it will be treated differently by Mixpanel
        //   https://mixpanel.com/help/questions/articles/special-or-reserved-properties

        if (params) {
          if (this.platform == 'reactjs') {
            mixpanelDriver.people.set(params);
          } else {
            mixpanelDriver.set(params);
          }
        }
      }
    }
  }, {
    key: "page",
    value: function page(pageName) {
      if (googleTracker) {
        if (this.platform == 'reactjs') {
          googleTracker.pageview(pageName);
        } else {
          googleTracker.trackScreenView(pageName);
        }
      }
    }
  }, {
    key: "track",
    value: function track(eventName, params) {
      if (googleTracker) {
        if (this.platform == 'reactjs') {
          console.log('should send event to google');
          googleTracker.event({
            category: 'UserEvent',
            action: eventName
          });
        } else {
          googleTracker.trackEvent(eventName, 'N/A', params);
        }
      }

      if (mixpanelDriver) {
        if (this.platform == 'reactjs') {
          mixpanelDriver.track(eventName, params);
        } else {
          mixpanelDriver.trackWithProperties(eventName, params);
        }
      }
    }
  }]);

  return CLIntegrations;
}();

module.exports = CLIntegrations;